export const FINANCE_TEMP_AUDIT_ROLE_OPTIONS = [
  { value: 'finance-temp', label: '只读' },
  { value: 'finance-temp-viewer', label: '浏览' },
];

export function buildFinanceTempSeedPayload(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => ({
      username: String(row?.username || '').trim(),
      name: String(row?.name || '').trim(),
      department: String(row?.deptL3 || row?.deptL2 || row?.deptL1 || row?.department || '').trim(),
      auditRole: String(row?.auditRole || '').trim() || 'finance-temp-viewer',
      templateId: String(row?.templateId || '').trim(),
    }))
    .filter((row) => row.username);
}

export function buildFinanceOrgTreeHintMessage(orgLoading, firstLevelOptions) {
  if (orgLoading) return '组织架构加载中...';
  if (Array.isArray(firstLevelOptions) && firstLevelOptions.length) {
    return '提示：提交时将优先使用三级部门，其次二级部门。';
  }
  return '未加载到组织架构，请检查登录状态或组织架构配置。';
}

export function buildFinanceTempCredentialExportRows(resultRows) {
  if (!Array.isArray(resultRows)) return [];
  return resultRows.map((row) => ({
    '账号': row?.username || '',
    '初始密码': row?.tempPassword || '',
    '姓名': row?.name || '',
    '部门': row?.department || '',
    '权限等级': row?.auditRole || '',
    '备注': '首次登录后请立即修改密码',
  }));
}

export function buildTempScopeChangeLogExportRows(changeLogs) {
  if (!Array.isArray(changeLogs)) return [];
  return changeLogs.map((log) => ({
    '变更时间': log?.timestamp ? new Date(log.timestamp).toLocaleString('zh-CN') : '',
    '操作人': log?.operator?.username || '',
    '目标账号': log?.target?.username || '',
    '目标部门': log?.target?.auditGroup || '',
    '模板ID': log?.template?.templateId || '',
    '模板名称': log?.template?.templateName || '',
    '模板版本': log?.template?.templateVersion || '',
    '风险可见页签(前)': (log?.diff?.riskVisibleTabs?.before || []).join('、'),
    '风险可见页签(后)': (log?.diff?.riskVisibleTabs?.after || []).join('、'),
    '风险可编辑部门(前)': (log?.diff?.riskEditableDepartments?.before || []).join('、'),
    '风险可编辑部门(后)': (log?.diff?.riskEditableDepartments?.after || []).join('、'),
    '内控可见模块(前)': (log?.diff?.internalVisibleDraftGroups?.before || []).join('、'),
    '内控可见模块(后)': (log?.diff?.internalVisibleDraftGroups?.after || []).join('、'),
  }));
}

export function buildTimestampedExportFilename(prefix, now = new Date()) {
  const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
  return `${prefix}_${stamp}.xlsx`;
}
